import type { CreateAppointmentPayload } from "@/app/pmc/appointments/appointments.entity";
import { importPlannedRows, type BulkUploadResult } from "@/app/shared/appointments/bulk-upload-import";
import type { PlannedAppointmentRow } from "@/app/shared/appointments/bulk-upload-plan";
import { api } from "@/lib/api";
import { createAppointmentBooking } from "@/lib/appointment-booking";
import { requirePermission } from "@/lib/permissions";
import { toAppointmentJoin } from "@/repositories/appointment-records";
import { activeOrganization, type AppointmentJoin } from "@/repositories/appointments.repository";

const book = createAppointmentBooking(api.appointments);

export type BookingPayload = Omit<CreateAppointmentPayload, "vendor"> & Partial<Pick<CreateAppointmentPayload, "vendor">>;

export async function bookAppointment({ property, unit, service, vendor, date, work_order_notes }: BookingPayload): Promise<AppointmentJoin> {
  return toAppointmentJoin(await book({ property, unit, service, date, ...(vendor ? { vendor } : {}), workOrderNotes: work_order_notes }, activeOrganization()));
}

export async function bookBulkUploadRows(
  planned: PlannedAppointmentRow[],
  onProgress?: (completed: number, total: number) => void
): Promise<BulkUploadResult> {
  await requirePermission("appointments.create");
  return importPlannedRows(planned, (booking) => book(booking, activeOrganization()), onProgress);
}
